import { Button, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../state/refresh'
import {
  isAnyStringEmpty,
  validateUsername,
  validatePassword
} from '../utils/validators'
import { useRequests } from '../requests/useRequests'
import Avatar from '@mui/material/Avatar'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { backgroundStyle } from '../styles/background'
// import { GoogleLogin } from '@react-oauth/google'

const Login = (): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const requestMaker = useRequests()
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [usernameError, setUsernameError] = useState<string | null>(null)
  const [passwordError, setPasswordError] = useState<string | null>(null)
  const [isActiveButton, setIsActiveButton] = useState(false)
  const [isRegisterRedirect, setIsRegisterRedirect] = useState(false)
  const [isLoginSuccesfull, setIsLoginSuccesfull] = useState(false)

  useEffect(() => {
    if (!isAnyStringEmpty([username, password])) {
      setIsActiveButton(true)
    } else {
      setIsActiveButton(false)
    }
  }, [username, password])

  const handleLogIn = async (): Promise<void> => {
    if (
      validateUsername(username, setUsernameError) &&
      validatePassword(password, setPasswordError)
    ) {
      try {
        const tokenResponse = await requestMaker.getToken({
          username,
          password
        })
        localStorage.setItem('MyPath-username', username)
        localStorage.setItem('MyPath-password', password)
        localStorage.setItem(
          'MyPath-jwtToken',
          tokenResponse.data.Authorization
        )
        dispatch(
          RefreshActions.setToastMessage({ message: 'Login succesfull' })
        )
        dispatch(RefreshActions.refreshUserState())
        setIsLoginSuccesfull(true)
      } catch (e) {
        setPasswordError('Incorrect password')
      }
    }
  }

  const handleGoogleLogIn = async (credentials: {
    credential: string
    select_by: string
    clientId: string
  }): Promise<void> => {
    try {
      const googleToken = credentials.credential
      const tokenResponse = await requestMaker.getToken({
        googleToken
      })
      localStorage.setItem('MyPath-googleToken', googleToken)
      localStorage.setItem('MyPath-jwtToken', tokenResponse.data.Authorization)
      dispatch(RefreshActions.setToastMessage({ message: 'Login succesfull' }))
      dispatch(RefreshActions.refreshUserState())
      setIsLoginSuccesfull(true)
    } catch (e) {
      setPasswordError('Incorrect login')
    }
  }

  const handleChangeUsername = async (username: string): Promise<void> => {
    setUsername(username)
    if (username === '') {
      return
    }
    const response = await requestMaker.emailOrUsernameExists(username)

    if (response.data) {
      setUsernameError(null)
    } else {
      setUsernameError('User with this username does not exist')
    }
  }

  useEffect(() => {
    if (isRegisterRedirect) {
      navigate('/register')
    }
    if (isLoginSuccesfull) {
      navigate('/')
    }
  }, [isRegisterRedirect, isLoginSuccesfull])

  return (
    <form
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault()
          void handleLogIn()
        }
      }}
    >
      <img
        src='./circles.png'
        style={{ width: '15%', position: 'absolute', marginTop: '20vh' }}
      />
      <Container component='main' maxWidth='xs'>
        <div style={backgroundStyle} />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <img src='./IB.png' style={{ width: '30%' }} />
          <Typography
            component='h1'
            variant='h5'
            style={{ marginBottom: '5vh' }}
          >
            Sign in
          </Typography>
          {/* <GoogleLogin
            onSuccess={handleGoogleLogIn as any}
            onError={() => {
              setPasswordError('There was an error during google login')
            }}
            auto_select
          /> */}
          <TextField
            error={usernameError !== null}
            variant='filled'
            helperText={usernameError}
            value={username}
            onChange={e => {
              setUsernameError(null)
              setUsername(e.target.value)
            }}
            onBlur={e => {
              void handleChangeUsername(e.target.value)
            }}
            margin='normal'
            required
            fullWidth
            id='username'
            label='Username or Email'
            name='username'
            autoComplete='username'
            autoFocus
          />
          <TextField
            error={passwordError !== null}
            variant='filled'
            helperText={passwordError}
            type='password'
            value={password}
            onChange={e => {
              setPasswordError(null)
              setPassword(e.target.value)
            }}
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            id='password'
            autoComplete='current-password'
          />
          {/* <FormControlLabel
            control={<Checkbox value='remember' color='primary' />}
            label='Remember me'
          /> */}
          <Button
            type='submit'
            fullWidth
            variant='contained'
            sx={{ mt: 3, mb: 2 }}
            disabled={!isActiveButton}
            onClick={e => {
              e.preventDefault()
              void handleLogIn()
            }}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault()
                void handleLogIn()
              }
            }}
            tabIndex={0}
          >
            Sign In
          </Button>
          <Grid container>
            <Grid item xs>
              <Link
                style={{ cursor: 'pointer' }}
                variant='body2'
                onClick={() => navigate('/forgot-password')}
              >
                Forgot password?
              </Link>
            </Grid>
            {/* <Grid item>
              <Link
                style={{ cursor: 'pointer' }}
                variant='body2'
                onClick={() => setIsRegisterRedirect(true)}
              >
                Don't have an account? Sign Up
              </Link>
            </Grid> */}
          </Grid>
        </Box>
      </Container>
    </form>
  )
}

export default Login
